<div class="modal">
  <div class="container model-container email-verification">
    <div class="modal-header">
      <div class="success-image">
        <img src="/assets/icon/email-verification.svg" width="180" height="180">
      </div>
      <h4 class="header" translate>email-verification-modal.header</h4>
    </div>
    <div class="modal-body">
      <div class="modal-content">
        <div class="info">
          <p translate>
            email-verification-modal.body
          </p>
        </div>
        <div class="row modal-actions">
          <button class="button primary" (click)="sendCode()" translate>email-verification-modal.verify-now</button>
        </div>
      </div>
    </div>
  </div>
</div>
